// Validation Engine — feature gate (pure logic).
//
// This is an in-development vertical slice (Hypothesis Intake + Reality Check),
// so it DEFAULTS OFF. Enablement precedence:
//   1. local kill (localStorage 'validation_engine_kill'=1)  → off
//   2. global env override (VITE_VALIDATION_ENGINE = on|off)
//   3. local opt-in (localStorage 'validation_engine_optin'=1) → on
//   4. default                                                → OFF
//
// Mirrors the shape of blockLibraryFlags.ts but single-tier and fail-OFF
// (the block library defaults ON because it's shipped; this isn't yet).

import { publicEnv } from './clientEnv';

export type ValidationGate = { enabled: boolean; reason: string };

export const VALIDATION_ENGINE_OPTIN_KEY = 'validation_engine_optin';
export const VALIDATION_ENGINE_KILL_KEY = 'validation_engine_kill';

function ls(key: string): string | null {
  try { return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null; } catch { return null; }
}

export function validationEngineGate(): ValidationGate {
  const on = (reason: string): ValidationGate => ({ enabled: true, reason });
  const off = (reason: string): ValidationGate => ({ enabled: false, reason });

  if (ls(VALIDATION_ENGINE_KILL_KEY) === '1') return off('local_kill');
  const e = (publicEnv('VITE_VALIDATION_ENGINE') ?? '').toLowerCase();
  if (e === 'on') return on('env_on');
  if (e === 'off') return off('disabled_globally');
  if (ls(VALIDATION_ENGINE_OPTIN_KEY) === '1') return on('local_optin');
  return off('default_off'); // in-development → off until explicitly enabled
}

// Dev/QA convenience: flip the per-browser opt-in.
export function engageValidationEngine(on: boolean): void {
  try {
    if (on) localStorage.setItem(VALIDATION_ENGINE_OPTIN_KEY, '1');
    else localStorage.removeItem(VALIDATION_ENGINE_OPTIN_KEY);
  } catch { /* ignore */ }
}
